export default {
      id: "icon--chevron-down-usage",
      viewBox: "0 0 13 7",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }